
export namespace ImagesService {

  export const filterValidImages = async (urls: string[]): Promise<string[]> => {
    const promises = urls.map(url => 
      fetch(url, { method: 'HEAD' })
        .then(response => response.ok ? url : null)
        .catch(e => null)
    );
  
    const results = await Promise.all(promises);
    return results.filter(url => url !== null);
  }
  
}